export default "__VITE_ASSET__CbJehc_j__"